<template>
    <!-- faceted search area -->
    <div
        v-if="masterTags.length > 0 || tags.length > 0"
        class="searchCard hideOnMobile--block">
        <div class="searchCard__box">
            <div class="searchCard__head flex flex__justifyItems--start flex__alignItems--center">
                <svg
                    class="searchIcon--32 searchIcon__right"
                    height="32"
                    width="32"
                    aria-hidden="true">
                    <use href="#iconTagDuo" />
                </svg>
                <span class="searchCard__headline">
                    {{ trans('MOST_USED_TAGS') }}
                </span>
                <!-- tooltip -->
                <div class="facetedSearch__tooltip flex">
                    <svg
                        class="searchIcon--16 facetedSearch_info searchIcon__left"
                        height="16"
                        width="16"
                        aria-hidden="true">
                        <use href="#iconInfoReg" />
                    </svg>
                    <span class="facetedSearch__tooltipText">
                        {{ trans('SELECT_MOST_USED_TAGS_INFO') }}
                    </span>
                </div>
            </div>
            <!-- selected Tags -->
            <div class="facetedSearch__content facetedSearch__content--selected flex">
                <button
                    v-for="tag in tags"
                    :key="tag"
                    type="button"
                    data-faceted-search
                    class="facetedSearch__tag facetedSearch__tag--selected flex flex__alignItems--center"
                    :data-gtm="`facetedSearch__removeTag${ tag }`"
                    :aria-label="`Remove tag ${ tag }`"
                    @click="removeTag(tag)"
                    @keydown.left="changeFocus">
                    <span class="facetedSearch__tag--ellipsis facetedSearch__tag--ellipsisSelected">{{ tag }}</span>
                    <svg
                        class="searchIcon--16 facetedSearch__deleteIcon"
                        height="16"
                        width="16"
                        aria-hidden="true">
                        <use href="#iconCrossBold" />
                    </svg>
                </button>
            </div>
            <!-- unselected Tags -->
            <div class="facetedSearch__content flex">
                <div
                    v-for="tagsOption in tagsOptions"
                    :key="tagsOption.tag">
                    <div v-if="!tags.includes(tagsOption.tag)">
                        <button
                            type="button"
                            class="facetedSearch__tag facetedSearch__tag--ellipsis"
                            :data-gtm="`facetedSearch__tag--${ tagsOption.tag }`"
                            data-faceted-search
                            @click="addTag(tagsOption.tag)"
                            @keydown.left="changeFocus">
                            <span>{{ tagsOption.tag }}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- reset tag area -->
        <div
            v-if="tags.length > 0"
            class="facetedSearch__reset flex flex__justifyContent--center flex__alignItems--center">
            <button
                type="button"
                class="facetedSearch__resetText"
                data-gtm="facetedSearch__resetAllTags"
                @click="resetTags()">
                {{ trans('RESET_MOST_USED_TAGS') }}
                <svg
                    class="searchIcon--16 searchIcon__left facetedSearch__resetIcon"
                    height="16"
                    width="16"
                    aria-hidden="true">
                    <use href="#iconArrowClockwiseBold" />
                </svg>
            </button>
        </div>
    </div>
</template>
<script>
    import { mapGetters, mapActions, mapMutations } from 'vuex';
    import Translator from 'tools/trans';
    export default {
        name: 'FacetedSearch',
        computed: {
            ...mapGetters('search', [
                'tagsOptions',
                'masterTags',
                'tags',
            ]),
        },
        methods: {
            ...mapActions('search', [
                'resetTagsPage',
                'setTags',
                'unsetTags',
                'resetAllTags',
                'calculateWhichBannerToShow',
            ]),
            ...mapMutations('search', [
                'resetTags',
            ]),
            trans: Translator.trans,
            async addTag(value) {
                this.resetTagsPage();
                await this.setTags(value);
            },
            async removeTag(value) {
                this.resetTagsPage();
                await this.unsetTags(value);
            },
            async resetTags() {
                this.resetTagsPage();
                await this.resetAllTags();
            },
            changeFocus() {
                const resultList = document.querySelector('[data-results]');
                resultList.firstElementChild.focus();
            },

        },
    };
</script>
